import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { FriesMenu } from '@/apps/menu/constants';
import { CONFIGURATOR_PRODUCT } from '@/apps/configurator/store/types';


@Component
export default class FriesMenuMixin extends Vue {
  @Getter itemByKey;
  @Getter productByKey;
  @Action(CONFIGURATOR_PRODUCT) setCurrentProduct;

  /**
   * Products to be iterated over.
   */
  get products() {
    return [
      {
        name:    'Regular Fries with Dipping Sauce',
        image:   this.productByKey(FriesMenu.FIRES_ID).image,
        onClick: () => this.openFries(),
      },
      {
        name:    'Fries with Cheese & Topping',
        image:   this.productByKey(FriesMenu.BOSS_YOUR_FIRES_ID).image,
        onClick: () => this.openBossYourFries(),
      },
    ];
  }

  /**
   * Open configurator from byf
   * @returns {Promise<void>}
   */
  async openBossYourFries() {
    await this.setCurrentProduct({ productKey: FriesMenu.BOSS_YOUR_FIRES_ID });
    this.$router.push({ name: 'configurator' });
  }

  /**
   * Open configurator from fries
   * @returns {Promise<void>}
   */
  async openFries() {
    await this.setCurrentProduct({ productKey: FriesMenu.FIRES_ID });
    this.$router.push({ name: 'configurator' });
  }
}



// WEBPACK FOOTER //
// ./src/apps/menu/mixins/fries-menu-mixin.js